import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Sponsors from "./pages/Sponsors";
import Activations from "./pages/Activations";
import Deliverables from "./pages/Deliverables";
import FleaMarket from "./pages/FleaMarket";
import BrandSpaces from "./pages/BrandSpaces";
import Tickets from "./pages/Tickets";
import Instagram from "./pages/Instagram";
import Ads from "./pages/Ads";
import Calendar from "./pages/Calendar";
import Outreach from "./pages/Outreach";
import Tables from "./pages/Tables";
import Team from "./pages/Team";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] grid place-items-center text-zinc-500">
        <div className="overline">Loading session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Overview /></Protected>} />
          <Route path="/sponsors" element={<Protected><Sponsors /></Protected>} />
          <Route path="/activations" element={<Protected><Activations /></Protected>} />
          <Route path="/flea-market" element={<Protected><FleaMarket /></Protected>} />
          <Route path="/deliverables" element={<Protected><Deliverables /></Protected>} />
          {/* Legacy redirect */}
          <Route path="/sponsorship" element={<Navigate to="/sponsors" replace />} />
          <Route path="/brand-spaces" element={<Protected><BrandSpaces /></Protected>} />
          <Route path="/tickets" element={<Protected><Tickets /></Protected>} />
          <Route path="/instagram" element={<Protected><Instagram /></Protected>} />
          <Route path="/ads" element={<Protected><Ads /></Protected>} />
          <Route path="/calendar" element={<Protected><Calendar /></Protected>} />
          <Route path="/outreach" element={<Protected><Outreach /></Protected>} />
          <Route path="/tables" element={<Protected><Tables /></Protected>} />
          <Route path="/team" element={<Protected><Team /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
